module.exports = __webpack_public_path__ + "static/img/1-1Z604140P4U3.9c74d62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z604140P4U3.jpg
// module id = 0Cmu
// module chunks = 0